import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b16f477"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mx-0 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto" }
const _hoisted_2 = { class: "fw-bold text-center fs-5 mb-5" }
const _hoisted_3 = { class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center" }
const _hoisted_4 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_5 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_6 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_7 = { class: "d-flex col-lg-4 pb-lg-0 pb-3 row" }
const _hoisted_8 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_9 = { class: "col-lg-10" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = { class: "d-flex col-lg-4 row" }
const _hoisted_13 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_14 = { class: "col-lg-10" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_17 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_18 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_19 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_20 = { class: "d-flex col-lg-4 pb-lg-0 pb-3 row" }
const _hoisted_21 = { class: "w-max-content col-lg-2 col-form-label text-nowrap text-black" }
const _hoisted_22 = { class: "col-lg-10" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_25 = { class: "d-flex col-lg-4 row" }
const _hoisted_26 = { class: "w-max-content col-lg-2 col-form-label text-nowrap text-black" }
const _hoisted_27 = { class: "col-lg-10" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_30 = { class: "row border-bottom mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_31 = { class: "w-max-content col-lg-3 text-black mar-right-1" }
const _hoisted_32 = { class: "col-lg-8 px-lg-0" }
const _hoisted_33 = { class: "text-black text-break fs-7" }
const _hoisted_34 = { class: "mx-0 px-0 text-black fs-7" }
const _hoisted_35 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_36 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_37 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_38 = { class: "mx-0 px-0 col-lg-4 row" }
const _hoisted_39 = { class: "col-lg-7 px-2 px-lg-3" }
const _hoisted_40 = { class: "input-group mb-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_42 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_43 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_44 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_45 = {
  id: "phone-number",
  class: "mx-0 px-0 col-lg-4 row"
}
const _hoisted_46 = { class: "d-flex px-2 px-lg-3" }
const _hoisted_47 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 px-lg-0 text-center align-self-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hyphen-position" }, " - ")
], -1))
const _hoisted_49 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 px-lg-0 text-center align-self-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hyphen-position" }, " - ")
], -1))
const _hoisted_51 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_52 = { class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center" }
const _hoisted_53 = { class: "border-bottom pb-4 gx-3 mb-4 d-flex flex-lg-row flex-column" }
const _hoisted_54 = { class: "w-max-content text-black pb-lg-0 pb-3 title-password fs-7" }
const _hoisted_55 = { class: "text-black fs-7" }
const _hoisted_56 = {
  id: "sns-linking-title",
  class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center"
}
const _hoisted_57 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_58 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_59 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_60 = { class: "row mx-0 px-0 col-lg-5 align-items-center" }
const _hoisted_61 = { class: "d-flex col-lg-10 px-2 justify-auth" }
const _hoisted_62 = { class: "form-check me-4" }
const _hoisted_63 = { class: "form-check-label fs-7" }
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "form-check me-4" }
const _hoisted_66 = { class: "form-check-label fs-7" }
const _hoisted_67 = ["value"]
const _hoisted_68 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_69 = { class: "w-max-content col-lg-3 col-form-label text-black" }
const _hoisted_70 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_71 = { class: "d-flex col-12 px-2 flex-xl-row flex-column" }
const _hoisted_72 = { class: "col-12 col-xl-7 me-4" }
const _hoisted_73 = ["title"]
const _hoisted_74 = ["title"]
const _hoisted_75 = {
  key: 2,
  class: "col-5 col-lg-3 me-4"
}
const _hoisted_76 = ["disabled"]
const _hoisted_77 = {
  key: 1,
  class: "col-form-label fs-7"
}
const _hoisted_78 = { class: "row mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_79 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_80 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }
const _hoisted_81 = {
  class: "modal fade",
  id: "editEmailUser",
  tabindex: "-1",
  "aria-labelledby": "editEmailUser",
  "aria-hidden": "true"
}
const _hoisted_82 = { class: "py-5 modal-dialog modal-lg" }
const _hoisted_83 = { class: "modal-content" }
const _hoisted_84 = { class: "modal-header" }
const _hoisted_85 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_86 = { class: "px-lg-5 pt-lg-5 pb-lg-3 p-3" }
const _hoisted_87 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_88 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_89 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_90 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_91 = { class: "col-lg-12" }
const _hoisted_92 = ["placeholder"]
const _hoisted_93 = {
  key: 0,
  class: "mt-1 email-same while-spaces"
}
const _hoisted_94 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_95 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_96 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_97 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_98 = { class: "col-lg-12" }
const _hoisted_99 = ["placeholder"]
const _hoisted_100 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_101 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_102 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_103 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_104 = {
  class: "modal fade",
  id: "editPasswordUser",
  tabindex: "-1",
  "aria-labelledby": "editPasswordUser",
  "aria-hidden": "true"
}
const _hoisted_105 = { class: "py-5 modal-dialog modal-lg" }
const _hoisted_106 = { class: "modal-content" }
const _hoisted_107 = { class: "modal-header" }
const _hoisted_108 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_109 = { class: "modal-body" }
const _hoisted_110 = { class: "text-center my-3" }
const _hoisted_111 = { class: "ms-2 my-4" }
const _hoisted_112 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_113 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_114 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_115 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_116 = { class: "col-lg-10" }
const _hoisted_117 = ["placeholder"]
const _hoisted_118 = { class: "mt-2" }
const _hoisted_119 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_120 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_121 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_122 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_123 = { class: "col-lg-10" }
const _hoisted_124 = ["placeholder"]
const _hoisted_125 = { class: "mt-2" }
const _hoisted_126 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_127 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_128 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_129 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_130 = { class: "col-lg-10" }
const _hoisted_131 = ["placeholder"]
const _hoisted_132 = { class: "mt-2" }
const _hoisted_133 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_134 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_135 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_136 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { ref, computed, watchEffect, onMounted, nextTick, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

// 2022/09/20 PhucNV Check current password invalid UAT#4416: SE40(Ph2-R20220922)
import { ACCOUNT_STORE } from '@/store/constants'
import { DEFAULT_MIN_LENGTH, DEFAULT_MAX_JP_TEXT, MIN_LENGTH_EMAIL, MAX_LENGTH_EMAIL } from '@/constants/number'
import useVuelidate from '@vuelidate/core'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { required, maxLength, minLength, email, sameAs, numeric } from '@vuelidate/validators'
import { customMaxLength, scrollToErrors } from '@/utils'
import dayjs from 'dayjs'
import { getBirthdayConfig } from '@/constants/datepicker'
import flatPickr from 'vue-flatpickr-component'
import { PASSWORD_REGEX, REGEX_EMOJI, SPECIAL_WORDS, PASSWORD_FORMAT_REGEX } from '@/constants/regex'
import ErrorMessage from '@/components/error-message/index.vue'
import ModalConfirmUpdate from './edit-confirm/index.vue'
import EditEmailConfirm from './edit-email/components/Confirm.vue'
import EditComplete from './edit-email/components/Complete.vue'
import { Modal } from 'bootstrap'
import EditCompletePassword from './edit-password/components/Complete.vue'
import employeesServices from '@/services/employees.service'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { getMessage } from '@/constants/messageCode.ts'
import { AuthenMethodTypes } from '@/store/modules/register-alumnus'
import { apiUrlSubpath, PATH } from '@/constants'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'
import { useToast } from 'vue-toastification'
import { useCountdown } from '@/use/useCountdown'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
const toast = useToast()
const emailSame = ref<string>('')

const editNormalData = computed(() => store.getters[ACCOUNT_STORE.GETTERS.EDIT_NORMAL_DATA])

const errorUpdate = ref<boolean>(false)

const modalUpdateConfirm = ref()

const fullPhoneNumber = computed(() => {
  const p1 = formData.value.phone_number_1 || '000'
  const p2 = formData.value.phone_number_2 || '0000'
  const p3 = formData.value.phone_number_3 || '0000'
  return `${p1}-${p2}-${p3}`
})
const { timeLeft, showCountTime, startCountdown } = useCountdown(`countdownEndTimeSendTest_${route.meta.screenId}`)
const submittingButton = ref<boolean>(false)

onMounted(() => {
  store.dispatch(ACCOUNT_STORE.ACTIONS.SET_EDIT_NORMAL_DATA)
  modalUpdateConfirm.value = new Modal(document.getElementById('confirmUpdateUserModal'))
})

const rules = computed(() => {
  return {
    family_name: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    given_name: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    family_name_kana: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      fullSizeKatakana: function (value) {
        return /^([ァ-ヶ]|ー)+$/.test(value)
      },
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    given_name_kana: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      fullSizeKatakana: function (value) {
        return /^([ァ-ヶ]|ー)+$/.test(value)
      },
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    birthday: {
      required,
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        const date = dayjs('1900/01/01').format('YYYY-MM-DD')
        if (!dayjs(value).isBefore(dayjs(date))) return true
      },
    },
    authentication_method: {
      required,
    },
    phone_number_1: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(5),
    },
    phone_number_2: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(4),
    },
    phone_number_3: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(4),
    },
  }
})

const formData = ref(editNormalData.value)
watchEffect(() => {
  formData.value = editNormalData.value
})

const v$ = useVuelidate(rules, formData)

const backToLobby = () => {
  router.push('/community/lobby')
}

const handleError = (status: boolean) => {
  errorUpdate.value = status
}

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()

  const isCheckedNGItems: Array<{ value: boolean }> = [isCheckedNGFamilyName, isCheckedNGGivenName, isCheckedNGFamilyNameKana, isCheckedNGGivenNameKana]
  isCheckedNGItems.forEach((checkedNGItem) => (checkedNGItem.value = false))
  await Promise.all([checkNGFamilyName(), checkNGGivenName(), checkNGFamilyNameKana(), checkNGGivenNameKana()])
  while (!isCheckedNGItems.every((checkedNGItem) => checkedNGItem.value)) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyFamilyName.value || ngKeyGivenName.value || ngKeyFamilyNameKana.value || ngKeyGivenNameKana.value) {
    nextTick(() => {
      scrollToErrors()
    })
    return
  }

  modalUpdateConfirm.value.show()
  store.dispatch(ACCOUNT_STORE.ACTIONS.UPDATE_EDIT_NORMAL_DATA, formData.value)
}

watchEffect(() => {
  localStorage.removeItem('checkSubmit')
})

const modalConfirmEmail = ref()
const modalEmail = ref()

const formDataEmail = ref({
  email: '',
  emailConfirm: '',
})

const emailRules = computed(() => {
  return {
    email: {
      required,
      minLength: minLength(MIN_LENGTH_EMAIL),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    emailConfirm: {
      required,
      minLength: minLength(MIN_LENGTH_EMAIL),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
      sameAsEmail: sameAs(formDataEmail.value.email),
    },
  }
})

const email_v$ = ref(useVuelidate(emailRules, formDataEmail))
// 2022/09/14 TienNV Fix double click confirm email
const loadingConfirmMail = ref(false)

const submitConfirmEmail = async (): void => {
  loadingConfirmMail.value = true
  email_v$.value.$touch()
  if (email_v$.value.$invalid) {
    // 2022/09/29 PhucNV Fixbug button confirm keeps showing circle marks UAT#4484: SE40
    loadingConfirmMail.value = false
    nextTick(() => {
      scrollToErrors('.invalid-feedback', '#editEmailUser')
    })
    return
  }

  try {
    const response = await employeesServices.checkEmailDuplicate({ email: formDataEmail.value.email })
    if (response?.status === 200) {
      modalEmail.value?.hide()
      modalConfirmEmail.value?.show()
    } else {
      emailSame.value = response?.response?.data?.data[0]?.message_code
    }
    // 2022/09/29 PhucNV Fixbug button confirm keeps showing circle marks UAT#4484: SE40
    loadingConfirmMail.value = false
  } catch (error) {
    loadingConfirmMail.value = false
    console.log(error)
  }

  // store.dispatch(USER_STORE.ACTIONS.SET_ALUMNI_PROFILE, formDataEmail.value)
}

const formDataPassword = ref({
  password: '',
  password_confirmation: '',
})

const serverError = ref<boolean>(false)
const validateNotChange = ref<boolean>(false)
const modalComplete = ref()
const modalEditPassword = ref()

// const { withAsync } = helpers
// const ngWord = withAsync(async () => {
//   try {
//     const data = await commonService.sendNGWordCheck({ sentence: password_v$.value.password.$model })
//     return !data.data?.data?.has_ngword
//   } catch (e) {
//     return false
//   }
// })

const passwordRules = computed(() => {
  return {
    password: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      //ngWord,
      containsSpecialWords: function (value) {
        let count = 0
        SPECIAL_WORDS.forEach((e) => {
          if (value === e) count++
        })

        if (count === 0) return true
      },
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
      containsTypeSpecialCharacter: function (value) {
        // let count = 0
        let count = 0
        ;[...value].forEach((e) => {
          if (PASSWORD_FORMAT_REGEX.test(e)) count++
        })
        if (count === value.length) return true
      },
      containsType: function (value) {
        return PASSWORD_REGEX.test(value)
      },
    },
    password_confirmation: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      sameAsPassword: sameAs(formDataPassword.value.password),
    },
    // 2022/09/20 PhucNV Check current password invalid UAT#4416: SE40(Ph2-R20220922)
    current_password: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      containsSpecialWords: function (value) {
        let count = 0
        SPECIAL_WORDS.forEach((e) => {
          if (value === e) count++
        })

        if (count === 0) return true
      },
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
      containsTypeSpecialCharacter: function (value) {
        let count = 0
        ;[...value].forEach((e) => {
          if (PASSWORD_FORMAT_REGEX.test(e)) count++
        })
        if (count === value.length) return true
      },
      containsType: function (value) {
        return PASSWORD_REGEX.test(value)
      },
    },
  }
})

const password_v$ = useVuelidate(passwordRules, formDataPassword)

// 2022/09/20 PhucNV Check current password invalid UAT#4416: SE40(Ph2-R20220922)
const validateCurrentPassword = ref<boolean>(false)
const serverErrorCode = ref<string>('')

// 2022/09/14 TienNV Fix double click confirm password
const loadingConfirmPassword = ref(false)

const submitPasswordConfirm = async (): Promise<void> => {
  loadingConfirmPassword.value = true
  password_v$.value.$touch()
  if (password_v$.value.$invalid) {
    loadingConfirmPassword.value = false
    nextTick(() => {
      scrollToErrors('.invalid-feedback', '#editPasswordUser')
    })
    return
  }

  try {
    const data = await employeesServices.employeesResetPassword({ ...formDataPassword.value })
    if (data.status === 200) {
      serverError.value = false
      validateNotChange.value = false
      modalEditPassword.value?.hide()
      modalComplete.value?.show()
      // 2022/09/14 TienNV Fix double click confirm password
      setTimeout(() => {
        loadingConfirmPassword.value = false
      }, 2000)
      return
    } else {
      // 2022/09/20 PhucNV Check current password invalid UAT#4416: SE40(Ph2-R20220922)
      let messageCode = data?.response?.data?.data[0]?.message_code
      serverErrorCode.value = messageCode
      loadingConfirmPassword.value = false

      if (messageCode === 'VALIDATE_NOT_CHANGED') {
        validateNotChange.value = true
        return
      } else if (messageCode === 'VALIDATE_CURRENT_PASSWORD') {
        validateCurrentPassword.value = true
        return
      }
      serverError.value = true
    }
  } catch (error: any) {
    serverError.value = true
    loadingConfirmPassword.value = false
    console.log('error', error)
  }
}

const resetFormPassword = (): void => {
  password_v$.value.$reset()
  serverError.value = false
  emailSame.value = ''
  validateNotChange.value = false

  // 2022/09/20 PhucNV Check current password invalid UAT#4416: SE40(Ph2-R20220922)
  validateCurrentPassword.value = false
  Object.assign(formDataPassword.value, {
    password: '',
    password_confirmation: '',
    current_password: '',
  })
}

const resetFormEmail = (): void => {
  email_v$.value.$reset()
  emailSame.value = ''
  Object.assign(formDataEmail.value, {
    email: '',
    emailConfirm: '',
  })
}

onMounted(() => {
  modalComplete.value = new Modal(document.getElementById('editPasswordUserComplete'))
  modalEditPassword.value = new Modal(document.getElementById('editPasswordUser'))
})

onMounted(() => {
  modalConfirmEmail.value = new Modal(document.getElementById('confirmEditEmailUser'))
  modalEmail.value = new Modal(document.getElementById('editEmailUser'))
})
const changeEmail = () => {
  emailSame.value = ''
}
const isCheckedNGFamilyName = { value: false }
const ngKeyFamilyName = ref<boolean>(false)
const checkNGFamilyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.family_name.$model })
  ngKeyFamilyName.value = data.data?.data?.has_ngword
  isCheckedNGFamilyName.value = true
}, 200)

const isCheckedNGGivenName = { value: false }
const ngKeyGivenName = ref<boolean>(false)
const checkNGGivenName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.given_name.$model })
  ngKeyGivenName.value = data.data?.data?.has_ngword
  isCheckedNGGivenName.value = true
}, 200)

const isCheckedNGFamilyNameKana = { value: false }
const ngKeyFamilyNameKana = ref<boolean>(false)
const checkNGFamilyNameKana = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.family_name_kana.$model })
  ngKeyFamilyNameKana.value = data.data?.data?.has_ngword
  isCheckedNGFamilyNameKana.value = true
}, 200)

const isCheckedNGGivenNameKana = { value: false }
const ngKeyGivenNameKana = ref<boolean>(false)
const checkNGGivenNameKana = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.given_name_kana.$model })
  ngKeyGivenNameKana.value = data.data?.data?.has_ngword
  isCheckedNGGivenNameKana.value = true
}, 200)
const sendTestPhoneNumber = debounce(async () => {
  submittingButton.value = true
  const p1 = editNormalData.value.phone_number_1 || '000'
  const p2 = editNormalData.value.phone_number_2 || '0000'
  const p3 = editNormalData.value.phone_number_3 || '0000'
  const phoneNumber = `${p1}${p2}${p3}`
  try {
    const data = await commonService.sendTestPhoneNumber({ phone_number: phoneNumber })
    if (data?.response?.status === 400) {
      scrollToErrors('#phone-number')
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'バリデーションエラー',
        },
      })
      submittingButton.value = false
    } else if (data?.status !== 200) {
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'リクエストエラーが発生しました。しばらく経ってからアクセスしてください。',
        },
      })
      submittingButton.value = false
    } else {
      startCountdown(30)
    }
  } catch (error) {
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: 'リクエストエラーが発生しました。しばらく経ってからアクセスしてください。',
      },
    })
    submittingButton.value = false
  }
}, 200)
watch(showCountTime, (newVal) => {
  submittingButton.value = newVal
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "container pt-5 pb-3 pb-lg-5 px-2",
      onSubmit: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('account')), 1),
        (errorUpdate.value)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              title: _unref(translate)('SE40serverErrorMessage')
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(translate)('basicInformation')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(translate)('nameKanji')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('surName')), 1),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "family_name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).family_name.$model) = $event)),
                class: _normalizeClass(['form-control', ngKeyFamilyName.value || _unref(v$).family_name.$error ? 'is-invalid' : '']),
                placeholder: _unref(translate)('placeholder'),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGFamilyName) && _unref(checkNGFamilyName)(...args)))
              }, null, 42, _hoisted_10), [
                [
                  _vModelText,
                  _unref(v$).family_name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyFamilyName.value && !_unref(v$).family_name.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: 'surName',
                params: [1, 20],
                validator: _unref(v$).family_name.$errors[0]?.$validator
              }, null, 8, ["validator"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('name')), 1),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "given_name",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).given_name.$model) = $event)),
                class: _normalizeClass(['form-control', ngKeyGivenName.value || _unref(v$).given_name.$error ? 'is-invalid' : '']),
                placeholder: _unref(translate)('placeholder'),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGGivenName) && _unref(checkNGGivenName)(...args)))
              }, null, 42, _hoisted_15), [
                [
                  _vModelText,
                  _unref(v$).given_name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyGivenName.value && !_unref(v$).given_name.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('name'),
                params: [1, 20],
                validator: _unref(v$).given_name.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('nameKatakana')), 1),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)('surNameKatakana')), 1),
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "family_name_kana",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).family_name_kana.$model) = $event)),
                class: _normalizeClass(['form-control', ngKeyFamilyNameKana.value || _unref(v$).family_name_kana.$error ? 'is-invalid' : '']),
                placeholder: _unref(translate)('placeholder'),
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(checkNGFamilyNameKana) && _unref(checkNGFamilyNameKana)(...args)))
              }, null, 42, _hoisted_23), [
                [
                  _vModelText,
                  _unref(v$).family_name_kana.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyFamilyNameKana.value && !_unref(v$).family_name_kana.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('surNameKatakana'),
                params: [1, 20],
                validator: _unref(v$).family_name_kana.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(translate)('lastNameKatakana')), 1),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "given_name_kana",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).given_name_kana.$model) = $event)),
                class: _normalizeClass(['form-control', ngKeyGivenNameKana.value || _unref(v$).given_name_kana.$error ? 'is-invalid' : '']),
                placeholder: _unref(translate)('placeholder'),
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(checkNGGivenNameKana) && _unref(checkNGGivenNameKana)(...args)))
              }, null, 42, _hoisted_28), [
                [
                  _vModelText,
                  _unref(v$).given_name_kana.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyGivenNameKana.value && !_unref(v$).given_name_kana.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('lastNameKatakana'),
                params: [1, 20],
                validator: _unref(v$).given_name_kana.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("label", _hoisted_31, _toDisplayString(_unref(translate)('email')), 1),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(editNormalData).email), 1),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", null, _toDisplayString(_unref(translate)('SE40pleaseEmail')), 1),
              _createElementVNode("span", {
                class: "hover-link text-decoration-underline cursor-pointer",
                "data-bs-toggle": "modal",
                "data-bs-target": "#editEmailUser",
                onClick: resetFormEmail
              }, _toDisplayString(_unref(translate)('SE40reset')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_unref(flatPickr), {
                  name: "select-birthday",
                  id: "select-birthday",
                  modelValue: _unref(v$).birthday.$model,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).birthday.$model) = $event)),
                  config: _unref(getBirthdayConfig)(_unref(v$).birthday.$model),
                  class: _normalizeClass(['form-control bg-white', _unref(v$).birthday.$error ? 'is-invalid' : ''])
                }, null, 8, ["modelValue", "config", "class"]),
                _hoisted_41
              ]),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('dateOfBirth'),
                params: [1990, 1, 1],
                validator: _unref(v$).birthday.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(translate)('PhoneNumber')), 1),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _withDirectives(_createElementVNode("input", {
                  type: "tel",
                  class: _normalizeClass(['form-control', _unref(v$).phone_number_1.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).phone_number_1.$model) = $event)),
                  name: "phone_number_1"
                }, null, 2), [
                  [
                    _vModelText,
                    _unref(v$).phone_number_1.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('PhoneNumber1'),
                  params: [_unref(DEFAULT_MIN_LENGTH), 5],
                  validator: _unref(v$).phone_number_1.$errors[0]?.$validator
                }, null, 8, ["title", "params", "validator"])
              ]),
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _withDirectives(_createElementVNode("input", {
                  type: "tel",
                  class: _normalizeClass(['form-control', _unref(v$).phone_number_2.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).phone_number_2.$model) = $event)),
                  name: "phone_number_2"
                }, null, 2), [
                  [
                    _vModelText,
                    _unref(v$).phone_number_2.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('PhoneNumber2'),
                  params: [_unref(DEFAULT_MIN_LENGTH), 4],
                  validator: _unref(v$).phone_number_2.$errors[0]?.$validator
                }, null, 8, ["title", "params", "validator"])
              ]),
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _withDirectives(_createElementVNode("input", {
                  type: "tel",
                  class: _normalizeClass(['form-control', _unref(v$).phone_number_3.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).phone_number_3.$model) = $event)),
                  name: "phone_number_3"
                }, null, 2), [
                  [
                    _vModelText,
                    _unref(v$).phone_number_3.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('PhoneNumber3'),
                  params: [_unref(DEFAULT_MIN_LENGTH), 4],
                  validator: _unref(v$).phone_number_3.$errors[0]?.$validator
                }, null, 8, ["title", "params", "validator"])
              ])
            ])
          ])
        ]),
        _createElementVNode("h3", _hoisted_52, _toDisplayString(_unref(translate)('SA20passwordSecret')), 1),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(translate)('password')), 1),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("span", null, _toDisplayString(_unref(translate)('SE40pleasePass')), 1),
            _createElementVNode("span", {
              class: "hover-link text-decoration-underline cursor-pointer",
              "data-bs-toggle": "modal",
              "data-bs-target": "#editPasswordUser",
              onClick: resetFormPassword
            }, _toDisplayString(_unref(translate)('SE40reset')), 1)
          ])
        ]),
        _createElementVNode("h3", _hoisted_56, _toDisplayString(_unref(translate)(`twoFA`)), 1),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("label", _hoisted_58, _toDisplayString(_unref(translate)(`method`)), 1),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("label", _hoisted_63, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "authentication_method",
                    value: _unref(AuthenMethodTypes).SMS,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).authentication_method.$model) = $event))
                  }, null, 8, _hoisted_64), [
                    [_vModelRadio, _unref(v$).authentication_method.$model]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)(`useSMS`)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("label", _hoisted_66, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "authentication_method",
                    value: _unref(AuthenMethodTypes).EMAIL,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(v$).authentication_method.$model) = $event))
                  }, null, 8, _hoisted_67), [
                    [_vModelRadio, _unref(v$).authentication_method.$model]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)(`useEmail`)), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("label", _hoisted_69, _toDisplayString(_unref(v$).authentication_method.$model === _unref(AuthenMethodTypes).EMAIL ? _unref(translate)(`email`) : _unref(translate)(`phone`)), 1),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(['form-control', 'show-info-field']),
                      name: "phone",
                      title: _unref(fullPhoneNumber)?.trim()
                    }, _toDisplayString(_unref(fullPhoneNumber) || _unref(translate)(`phoneExample`)), 9, _hoisted_73))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(['form-control', 'show-info-field']),
                      name: "email",
                      title: _unref(editNormalData).email?.trim()
                    }, _toDisplayString(_unref(editNormalData).email || 'sample@yelloop.jp'), 9, _hoisted_74)),
                _createElementVNode("div", {
                  class: _normalizeClass(['col-lg-12 col-form-label fs-7 while-spaces', { 'text-danger': _unref(v$).authentication_method.$model === _unref(AuthenMethodTypes).SMS }])
                }, _toDisplayString(_unref(v$).authentication_method.$model === _unref(AuthenMethodTypes).EMAIL ? _unref(translate)(`showRegisteredEmailMessage`) : _unref(translate)(`showRegisteredPhoneMessage`)), 3),
                (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "button-test shadow button-router-link",
                            disabled: 
                    _unref(v$).phone_number_1.$error ||
                    _unref(v$).phone_number_2.$error ||
                    _unref(v$).phone_number_3.$error ||
                    !_unref(v$).phone_number_1.$model ||
                    !_unref(v$).phone_number_2.$model ||
                    !_unref(v$).phone_number_3.$model ||
                    _unref(showCountTime) ||
                    submittingButton.value
                  ,
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_unref(sendTestPhoneNumber) && _unref(sendTestPhoneNumber)(...args)))
                          }, _toDisplayString(_unref(translate)(`testSend`)), 9, _hoisted_76))
                        : _createCommentVNode("", true),
                      (_unref(showCountTime))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_unref(timeLeft)) + "秒後に再送可能です ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createVNode(Button, {
              title: _unref(translate)('CO40buttonTop'),
              type: 'secondary',
              onClick: backToLobby
            }, null, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createVNode(Button, {
              class: "button-submit",
              title: _unref(translate)('confirm'),
              type: 'secondary',
              onClick: onSubmit
            }, null, 8, ["title"])
          ])
        ])
      ])
    ], 32),
    _createVNode(ModalConfirmUpdate, {
      errorUpdate: errorUpdate.value,
      handleError: handleError
    }, null, 8, ["errorUpdate"]),
    _createElementVNode("div", _hoisted_81, [
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("h5", _hoisted_85, _toDisplayString(_unref(translate)('SE45resetEmail')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetFormEmail
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("label", _hoisted_88, _toDisplayString(_unref(translate)('email')), 1),
                _createElementVNode("div", _hoisted_89, [
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((email_v$.value.email.$model) = $event)),
                      class: _normalizeClass(['form-control', email_v$.value.email.$error || emailSame.value ? 'is-invalid' : '']),
                      placeholder: _unref(translate)('placeholder'),
                      onKeyup: changeEmail
                    }, null, 42, _hoisted_92), [
                      [
                        _vModelText,
                        email_v$.value.email.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('email'),
                      params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                      validator: email_v$.value.email.$errors[0]?.$validator
                    }, null, 8, ["title", "params", "validator"]),
                    (emailSame.value && !email_v$.value.email.$error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_93, _toDisplayString(_unref(getMessage)(emailSame.value)), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("label", _hoisted_95, _toDisplayString(_unref(translate)('emailConfirm')), 1),
                _createElementVNode("div", _hoisted_96, [
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((email_v$.value.emailConfirm.$model) = $event)),
                      class: _normalizeClass(['form-control', email_v$.value.emailConfirm.$error ? 'is-invalid' : '']),
                      placeholder: _unref(translate)('SC52typeAgain')
                    }, null, 10, _hoisted_99), [
                      [
                        _vModelText,
                        email_v$.value.emailConfirm.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('emailConfirm'),
                      params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                      validator: email_v$.value.emailConfirm.$errors[0]?.$validator
                    }, null, 8, ["title", "params", "validator"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal",
                    onClick: resetFormEmail
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createVNode(Button, {
                    class: "button-submit",
                    title: _unref(translate)('SE40updateEmail'),
                    type: 'secondary',
                    onClick: submitConfirmEmail,
                    disabled: loadingConfirmMail.value,
                    loading: loadingConfirmMail.value
                  }, null, 8, ["title", "disabled", "loading"])
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createVNode(EditEmailConfirm, {
      email: formDataEmail.value.email,
      modalConfirmEmail: modalConfirmEmail.value
    }, null, 8, ["email", "modalConfirmEmail"]),
    _createVNode(EditComplete, { resetFormEmail: resetFormEmail }),
    _createElementVNode("div", _hoisted_104, [
      _createElementVNode("div", _hoisted_105, [
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("h5", _hoisted_108, _toDisplayString(_unref(translate)('SE47resetPassword')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetFormPassword
            })
          ]),
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("form", {
              onSubmit: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["prevent"]))
            }, [
              (serverError.value)
                ? (_openBlock(), _createBlock(ErrorMessage, {
                    key: 0,
                    title: _unref(translate)('SD40updatePasswordError')
                  }, null, 8, ["title"]))
                : (validateNotChange.value)
                  ? (_openBlock(), _createBlock(ErrorMessage, {
                      key: 1,
                      title: _unref(getMessage)(serverErrorCode.value)
                    }, null, 8, ["title"]))
                  : (validateCurrentPassword.value)
                    ? (_openBlock(), _createBlock(ErrorMessage, {
                        key: 2,
                        title: _unref(getMessage)(serverErrorCode.value)
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_110, _toDisplayString(_unref(translate)('SC52heading1')), 1),
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("div", _hoisted_112, [
                  _createElementVNode("label", _hoisted_113, _toDisplayString(_unref(translate)('password')), 1),
                  _createElementVNode("div", _hoisted_114, [
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(password_v$).password.$model) = $event)),
                        class: _normalizeClass(['form-control', _unref(password_v$).password.$error ? 'is-invalid' : '']),
                        placeholder: _unref(translate)('placeholder')
                      }, null, 10, _hoisted_117), [
                        [
                          _vModelText,
                          _unref(password_v$).password.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createVNode(InputErrorMessage, {
                        title: 'password',
                        params: [8, 128],
                        validator: _unref(password_v$).password.$errors[0]?.$validator
                      }, null, 8, ["validator"])
                    ]),
                    _createElementVNode("p", _hoisted_118, _toDisplayString(_unref(translate)('SB20noticePass')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("label", _hoisted_120, _toDisplayString(_unref(translate)('SE40passwordConfirm')), 1),
                  _createElementVNode("div", _hoisted_121, [
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("div", _hoisted_123, [
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(password_v$).password_confirmation.$model) = $event)),
                        class: _normalizeClass(['form-control', _unref(password_v$).password_confirmation.$error ? 'is-invalid' : '']),
                        placeholder: _unref(translate)('SC52typeAgain')
                      }, null, 10, _hoisted_124), [
                        [
                          _vModelText,
                          _unref(password_v$).password_confirmation.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createVNode(InputErrorMessage, {
                        title: _unref(translate)('SE40passwordConfirm'),
                        params: [8, 128],
                        validator: _unref(password_v$).password_confirmation.$errors[0]?.$validator
                      }, null, 8, ["title", "validator"])
                    ]),
                    _createElementVNode("p", _hoisted_125, _toDisplayString(_unref(translate)('SB20noticePassConfirm')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("label", _hoisted_127, _toDisplayString(_unref(translate)('currentPassword')), 1),
                  _createElementVNode("div", _hoisted_128, [
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("div", _hoisted_130, [
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(password_v$).current_password.$model) = $event)),
                        class: _normalizeClass(['form-control', _unref(password_v$).current_password.$error ? 'is-invalid' : '']),
                        placeholder: _unref(translate)('placeholder')
                      }, null, 10, _hoisted_131), [
                        [
                          _vModelText,
                          _unref(password_v$).current_password.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createVNode(InputErrorMessage, {
                        title: _unref(translate)('currentPassword'),
                        params: [8, 128],
                        validator: _unref(password_v$).current_password.$errors[0]?.$validator
                      }, null, 8, ["title", "validator"])
                    ]),
                    _createElementVNode("p", _hoisted_132, _toDisplayString(_unref(translate)('SD40noticeCurrentPass')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _createVNode(Button, {
                      title: _unref(translate)('cancel'),
                      type: 'secondary',
                      "data-bs-dismiss": "modal",
                      onClick: resetFormPassword
                    }, null, 8, ["title"])
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _createVNode(Button, {
                      class: "button-submit",
                      title: _unref(translate)('update'),
                      type: 'secondary',
                      onClick: submitPasswordConfirm,
                      loading: loadingConfirmPassword.value,
                      disabled: loadingConfirmPassword.value
                    }, null, 8, ["title", "loading", "disabled"])
                  ])
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(EditCompletePassword, { resetForm: resetFormPassword })
  ], 64))
}
}

})